import { EmployeeReviewProcessData } from '@/common/models/user/review-process/employee-review-process-data';

export const UserReviewProcessInfo = function () {
    this.employeeReviewProcessData = new EmployeeReviewProcessData();
    this.usersToManage             = [];
};